import { Component, OnInit, TemplateRef, viewChild } from '@angular/core';

import { inject } from '@angular/core';
import { MatDialogContainer } from '@angular/material/dialog';
import {
  CancelMemberequestDialogData,
  PuebloDialog,
  PuebloDialogs,
} from '@services/pueblo-dialogs.service';
import { DeleteDialog } from './delete-dialog/delete-dialog.component';
import { InterestInfoDialog } from './interest-info-dialog/interest-info-dialog.component';
import { InviteDialog } from './invite-dialog/invite-dialog.component';
import { LeavePuebloDialog } from './leave-pueblo-dialog/leave-pueblo-dialog.component';
import { OutlookIntegrationDialog } from './outlook-integration-dialog/outlook-integration-dialog.component';
import { PuebloInfoDialog } from './pueblo-info-dialog/pueblo-info-dialog.component';
import { PuebloJoinRequestsDialog } from './pueblo-join-requests-dialog/pueblo-join-requests-dialog.component';
import { PuebloMembersDialog } from './pueblo-members-dialog/pueblo-members-dialog.component';
import { SimpleDialog } from './simple-dialog/simple-dialog.component';

// To add a new sheet to this component, start with step 1 in
// services/pueblo-dialogs.service.ts

// 3. Add the new dialog component to the imports array below, then add
//    the dialog to the template.
@Component({
  selector: 'pueblo-dialogs',
  imports: [
    PuebloMembersDialog,
    PuebloJoinRequestsDialog,
    DeleteDialog,
    InterestInfoDialog,
    InviteDialog,
    LeavePuebloDialog,
    OutlookIntegrationDialog,
    PuebloInfoDialog,
    SimpleDialog,
  ],
  template: `
    <ng-template #deleteDialog let-data>
      <delete-dialog (deleteClicked)="data?.deleteClicked?.()"></delete-dialog>
    </ng-template>

    <ng-template #puebloMembersDialog let-data>
      <pueblo-members-dialog [pueblo]="data?.$pueblo()">
      </pueblo-members-dialog>
    </ng-template>

    <ng-template #puebloJoinRequestsDialog let-data>
      <pueblo-join-requests-dialog [pueblo]="data?.$pueblo()">
      </pueblo-join-requests-dialog>
    </ng-template>

    <ng-template #interestInfoDialog let-data>
      <interest-info-dialog [interest]="data.interest"></interest-info-dialog>
    </ng-template>

    <ng-template #puebloInfoDialog let-data>
      <pueblo-info-dialog [pueblo]="data.pueblo"></pueblo-info-dialog>
    </ng-template>

    <ng-template #inviteDialog let-data>
      <invite-dialog
        [url]="data.url"
        [shareSmsText]="data.shareSmsText"
        [emoji]="data.emoji"
        [entityDisplayName]="data.entityDisplayName"
        [entityResourceName]="data.entityResourceName"
        [entityType]="data.entityType"
        [omitUsers]="data.omitUsers ?? []"
      ></invite-dialog>
    </ng-template>

    <ng-template #outlookIntegrationDialog let-data>
      <outlook-integration-dialog
        [calendarUrl]="data.calendarUrl"
      ></outlook-integration-dialog>
    </ng-template>

    <ng-template #simpleDialog let-data>
      <simple-dialog
        [title]="data.title"
        [contentStr]="data.contentStr"
        [contentTmpl]="data.contentTmpl"
        [leftAction]="data.leftAction"
        [rightAction]="data.rightAction"
      ></simple-dialog>
    </ng-template>

    <ng-template #leavePuebloDialog let-data>
      <leave-pueblo-dialog
        [pueblo]="data.pueblo"
        (leaveComplete)="data?.leaveComplete?.()"
      ></leave-pueblo-dialog>
    </ng-template>
  `,
})
export class PuebloDialogsComponent implements OnInit {
  private readonly dialogs = inject(PuebloDialogs);

  // 4. Add a viewChild for the dialog component below.
  protected readonly $puebloMembersDialog = viewChild.required<
    TemplateRef<MatDialogContainer>
  >('puebloMembersDialog');

  protected readonly $puebloJoinRequestsDialog = viewChild.required<
    TemplateRef<MatDialogContainer>
  >('puebloJoinRequestsDialog');

  protected readonly $deleteDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('deleteDialog');

  protected readonly $firstPuebloDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('firstPuebloDialog');

  protected readonly $interestInfoDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('interestInfoDialog');

  protected readonly $puebloInfoDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('puebloInfoDialog');

  protected readonly $inviteDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('inviteDialog');

  protected readonly $outlookIntegrationDialog = viewChild.required<
    TemplateRef<MatDialogContainer>
  >('outlookIntegrationDialog');

  protected readonly $simpleDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('simpleDialog');

  protected readonly $leavePuebloDialog =
    viewChild.required<TemplateRef<MatDialogContainer>>('leavePuebloDialog');

  // 5. Register the dialog component with the PuebloDialogs service. All done!
  ngOnInit() {
    this.dialogs.register(
      PuebloDialog.PUEBLO_MEMBERS,
      this.$puebloMembersDialog(),
    );
    this.dialogs.register(
      PuebloDialog.PUEBLO_JOIN_REQUESTS,
      this.$puebloJoinRequestsDialog(),
    );
    this.dialogs.register(PuebloDialog.DELETE, this.$deleteDialog());
    this.dialogs.register(
      PuebloDialog.INTEREST_INFO_DIALOG,
      this.$interestInfoDialog(),
    );
    this.dialogs.register(
      PuebloDialog.PUEBLO_INFO_DIALOG,
      this.$puebloInfoDialog(),
    );
    this.dialogs.register(PuebloDialog.INVITE, this.$inviteDialog());
    this.dialogs.register(
      PuebloDialog.OUTLOOK_INTEGRATION,
      this.$outlookIntegrationDialog(),
    );
    this.dialogs.register(PuebloDialog.SIMPLE, this.$simpleDialog());
    this.dialogs.register(PuebloDialog.LEAVE_PUEBLO, this.$leavePuebloDialog());

    // Simple dialogs
    this.dialogs.registerSimple(
      PuebloDialog.CANCEL_SUBSCRIBE_REQUEST,
      (data) => {
        data = data as CancelMemberequestDialogData;
        return {
          title: 'Cancel request?',
          leftAction: {
            label: 'Never mind',
            error: false,
            close: true,
            type: 'default',
          },
          rightAction: {
            label: 'Cancel request',
            error: true,
            close: true,
            click: data.cancelClicked,
          },
        };
      },
    );
  }
}
